import React, {useEffect, useState} from "react";
import {FaMobileAlt} from "react-icons/fa";
import {FiLogOut} from "react-icons/fi";
import {removePediaActiveSessionById} from "../account/service";

type Props = {
    loggedInAt: string,
    deviceInfo: string,
    onLogout: (deviceId: any) => void,
    deviceId?: any
};

const DeviceCard: React.FC<Props> = ({
                                         deviceInfo,
                                         loggedInAt,
                                         onLogout,
                                         deviceId
                                     }) => {

    const [browser, os, version] = deviceInfo.split("_");

    function convertUtcToLocalDateTime(obj: any): Date {
        return new Date(Date.UTC(
            obj.year,
            obj.monthValue - 1, // JS months are 0-indexed
            obj.dayOfMonth,
            obj.hour,
            obj.minute,
            obj.second
        ));
    }


    function formatToLocalDisplayTime(obj: any): string {
        const localDate = convertUtcToLocalDateTime(obj);

        const day = localDate.getDate();
        const suffix =
            day === 1 || day === 21 || day === 31
                ? "st"
                : day === 2 || day === 22
                    ? "nd"
                    : day === 3 || day === 23
                        ? "rd"
                        : "th";

        const shortMonth = localDate.toLocaleString("default", {month: "short"});
        const year = localDate.getFullYear();

        const hours = localDate.getHours() % 12 || 12;
        const minutes = localDate.getMinutes().toString().padStart(2, "0");
        const ampm = localDate.getHours() >= 12 ? "PM" : "AM";

        return `${day}${suffix} ${shortMonth} ${year} ${hours}:${minutes} ${ampm}`;
    }



    return (
        <div className="bg-white text-black rounded-2xl p-6 mb-2 shadow-md w-full max-w-md border border-[#ccc]">
            <div className="flex justify-between items-center mb-3">
                <span className="font-semibold text-md">Device:</span>
                <div className="flex items-center gap-1 font-medium text-md">
                    <FaMobileAlt/> Mobile
                </div>
            </div>
            <div className="text-sm space-y-2">
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">Browser:</span>
                    <span>{browser}</span>
                </div>
                <hr/>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">Version:</span>
                    <span>{version}</span>
                </div>
                <hr/>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">OS:</span>
                    <span>{os}</span>
                </div>
                <hr/>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">Last logged In:</span>
                    <span>{formatToLocalDisplayTime(loggedInAt)}</span>
                </div>
            </div>

            <div className="flex justify-end flex-end mt-6">
                <button
                    onClick={() => onLogout(deviceId)}
                    className="flex items-center gap-2 border
                     border-[#4b4ad5] border-[2px] text-[#4b4ad5] px-2 py-2
                     rounded-xl text-sm font-semibold hover:bg-purple-50 transition"
                >
                    <FiLogOut/> Logout
                </button>
            </div>
        </div>
    );
};

export default DeviceCard;